<template>
    <div class="dash-banner-index">
        <a
            :href="linkBannerOne"
            target="_blank"
            :rel="makeRel(linkBannerOne)">
            <img alt="Banner" ref="banner">
        </a>
    </div>
</template>

<script>
export default {
    name: "dv5-bottom-banner",
    props: ["view", "app"],
    data() {
        return {
            allBanners: null,
            linkBannerOne: null,
            processingModal: false,
            windowWidth: 0,
            banner: null,
            bannerData: null
        };
    },
    mounted() {

        console.log('bottom-banner', this.view)

        // if (this.app == 'banners_ba5') {

        this.bannerData = JSON.parse(this.view),
        this.allBanners = this.bannerData[0].resolutions
        this.linkBannerOne = this.bannerData[0].action_link

        // } else {
        //
        //     this.allBanners = this.view['banners'],
        //     this.linkBannerOne = this.view['link']
        //
        // }

        window.addEventListener('resize', this.handleResize)
        this.handleResize();

    },
    created () {
    },

    methods: {

        handleResize() {

            this.windowWidth = window.innerWidth;

            if(this.windowWidth > 1336) {
                this.$refs.banner.src = this.allBanners[1920];
            }
            if(this.windowWidth <= 1336) {
                this.$refs.banner.src = this.allBanners[1336];
            }
            if(this.windowWidth <= 1280) {
                this.$refs.banner.src = this.allBanners[1280];
            }
            if(this.windowWidth <= 1024) {
                this.$refs.banner.src = this.allBanners[300];
            }
            if(this.windowWidth <= 700) {
                this.$refs.banner.src = this.allBanners[450];
            }
            if(this.windowWidth <= 325) {
                this.$refs.banner.src = this.allBanners[300];
            }

        },

        makeRel: function(url) {
            return url;
            // return this.makeTarget(url) == '_blank' ? 'noopener' : '';
        },

    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
 .dash-banner-index {
    a{
        overflow: hidden!important;
        height: 100%!important;
        width: 100%!important;
        display: block!important;
        margin: 0!important;
        padding: 0!important;
        border-radius: 4px!important;
        img {
            width: 100%; // variable
            height: 170px; // ever 170px
            background-size: cover!important;
            border-radius: 4px!important;
        }
    }
 }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/banners/BottomBanner.vue